import {
  FINGERSPELLING_ENTRIES,
  type FingerspellingEntry,
  type FingerspellingSide,
  getFingerspellingImageUrl,
} from "../../lib/fingerspelling";
import { FINGERSPELLING_ROWS } from "../../lib/fingerspelling-layout";

type FingerspellingTableProps = {
  side: FingerspellingSide;
  onSelect: (entry: FingerspellingEntry) => void;
};

const ENTRY_BY_ID: ReadonlyMap<string, FingerspellingEntry> = new Map(
  FINGERSPELLING_ENTRIES.map((entry) => [entry.id, entry]),
);

/** 50音表。紙の表のように5列で行ごとに並べる */
export const FingerspellingTable = ({
  side,
  onSelect,
}: FingerspellingTableProps) => (
  <div className="space-y-1">
    {FINGERSPELLING_ROWS.map((row, rowIndex) => {
      const entries = row.ids.flatMap((id) => ENTRY_BY_ID.get(id) ?? []);
      const showHeading =
        rowIndex === 0 ||
        FINGERSPELLING_ROWS[rowIndex - 1]?.label !== row.label;
      return (
        <div key={row.ids.join("-")}>
          {showHeading && (
            <h2 className="mt-3 mb-1 text-xs font-semibold text-neutral-500">
              {row.label}
            </h2>
          )}
          <div className="grid grid-cols-5 gap-1">
            {entries.map((entry) => (
              <button
                key={entry.id}
                type="button"
                onClick={() => onSelect(entry)}
                className="select-none touch-manipulation rounded-lg border border-neutral-200 bg-white p-0.5 text-center [-webkit-touch-callout:none]"
              >
                <img
                  src={getFingerspellingImageUrl(side, entry.id)}
                  alt={entry.kana}
                  draggable={false}
                  className="block w-full"
                />
                <span
                  aria-hidden="true"
                  className="block text-sm font-semibold"
                >
                  {entry.kana}
                </span>
              </button>
            ))}
          </div>
        </div>
      );
    })}
  </div>
);
